// extracted by mini-css-extract-plugin
export var externalLink = "_de-0";
export var internalLinkLabel = "_de-1";